
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function TeacherReportTableHeader() {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>วันที่</TableHead>
        <TableHead>ประเภทการสอน</TableHead>
        <TableHead>Tier</TableHead>
        <TableHead>ระดับชั้น</TableHead>
        <TableHead>นักเรียน</TableHead>
        <TableHead className="text-center">ส่งช้า</TableHead>
        <TableHead className="text-center">ถูกหัก 100%</TableHead>
        <TableHead className="text-center">ชีท</TableHead>
        <TableHead className="text-center">ลากะทันหัน</TableHead>
        <TableHead className="text-center">สถานะ</TableHead>
        <TableHead className="text-right">ชั่วโมง</TableHead>
        <TableHead className="text-right">รายได้ (บาท)</TableHead>
      </TableRow>
    </TableHeader>
  );
}
